import type { Props as SubscribeFormProps } from '@ff/ui/SubscribeForm';
import { COMPONENT_VALUE_TYPES as types, REGIONS } from 'shared/constants';
import type { EditorProps } from 'shared/internalTypes';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export type Props = SubscribeFormProps & EditorProps;

const propsSchema: PropsSchemaList = [
  {
    key: 'footerRegion',
    label: 'Region',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'submitUrl',
    label: 'Submit Url',
    type: types.TEXT
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT
  },
  {
    key: 'button',
    label: 'Button Text',
    type: types.TEXT
  },
  {
    key: 'inputPlaceholder',
    label: 'Input Placeholder Text',
    type: types.TEXT
  },
  {
    key: 'inputErrorMessage',
    label: 'Input Error Message',
    type: types.TEXT,
    tooltip: 'Shown when a user submits an invalid email address',
  },
  {
    key: 'serverErrorMessage',
    label: 'Submit Error Message',
    type: types.TEXT,
    tooltip: 'Shown when there is an issue submitting the form',
  },
  {
    key: 'successMessage',
    label: 'Submit Success Message',
    type: types.TEXT,
    tooltip: 'Shown when the form is submitted successfully',
  },
  {
    key: 'margin',
    label: 'Margin',
    type: types.TEXT,
    tooltip: 'Adds space around the form (Example: 10px 0px)',
  },
  {
    key: 'enabled',
    label: 'Enable/Disable',
    type: types.BOOLEAN,
    tooltip: 'Show or hide this widget',
  },
];

const defaultProps: Props = {
  footerRegion: 'US',
  submitUrl: '/api/subscribe',
  title: 'Get the latest news and important updates from FF',
  subtitle: 'Sign up for the latest of the FF 91 Futurist and other news about Faraday Future',
  button: 'Subscribe →',
  inputPlaceholder: 'Email*',
  inputErrorMessage: 'Please provide a valid email',
  serverErrorMessage: 'Something went wrong. Please try again later.',
  successMessage: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
  margin: '10px 0px',
  enabled: true,
};

export default {
  title: 'Subscribe Version 2',
  id: 'SubscribeV2',
  propsSchema,
  defaultProps
};
